import { PA_NAME } from "../types/product-attribute/product-attribute";
import { validateCalendar } from "../utils/bookingUtils";
import { logging } from "../utils/logging";
import {
  BookingAttributeHelper,
  ProdAttrUtils,
} from "../utils/productAttributeUtils";
import { useSearchParamsOfBooking } from "./searchParams/useSearchParamsOfBooking";

export const useAbleAdd2Cart = ({
  bookingAttributes,
  totalPrice,
  mode,
}: {
  bookingAttributes?: BookingAttributeDTO[];
  totalPrice?: number;
  mode: "FORM" | "POPUP";
}) => {
  const baHelper = new BookingAttributeHelper(bookingAttributes);
  const { isEdit } = useSearchParamsOfBooking();

  if (!isEdit && totalPrice !== undefined && !totalPrice) {
    // edit thì không cần check total price
    logging.debug("failed to add to cart because total price is 0");
    return false;
  }

  if (bookingAttributes !== undefined) {
    if (mode === "FORM") {
      //check if have required person or sim
      const requiredQuantityPersonOrSim = bookingAttributes.filter(
        (x) =>
          x.productAttribute.type === "OPTIONAL" &&
          PA_NAME.QUANTITY_REQUIRED.includes(x.productAttribute.name),
      );
      if (requiredQuantityPersonOrSim.length) {
        if (requiredQuantityPersonOrSim.some((x) => !x.value?.quantity)) {
          logging.debug(
            "failed to add to cart because required person or sim is not selected",
          );
          return false;
        }
      }

      // *BOOKMARK*: bắt buộc có người lớn
      // const defaultBooka = ProdAttrUtils.findDefaultBooka(bookingAttributes);
      // if (defaultBooka?.productAttribute?.value === "PASS") {
      //   if (
      //     !defaultBooka.value?.ageQuantities?.find((x) => x.age === "ADULT")
      //       ?.quantity
      //   ) {
      //     logging.debug(
      //       "failed to add to cart because required adult is not selected",
      //     );
      //     return false;
      //   }
      // }
    }

    if (!validateCalendar(bookingAttributes)) {
      logging.debug("failed to add to cart because calendar is not valid");
      return false;
    }

    const requiredQuantity = bookingAttributes.filter(
      (x) =>
        x.productAttribute.type === "OPTIONAL" &&
        PA_NAME.QUANTITY_REQUIRED_IN_POPUP.includes(x.productAttribute.name),
    );
    // logging.debug("requiredQuantity", requiredQuantity);
    if (requiredQuantity.length) {
      if (requiredQuantity.some((x) => !x.value?.quantity)) {
        logging.debug(
          "failed to add to cart because required person or sim is not selected",
        );
        return false;
      }
    }
    const simPa = baHelper.filter("SIM", "OPTIONAL");
    if (simPa.length) {
      if (!simPa.some((x) => typeof x.value?.quantity === "number")) {
        logging.debug(
          "failed to add to cart because required person or sim is not selected",
        );
        return false;
      }
    }

    const simDefaultPa = baHelper.filter("SIM", "DEFAULT");
    if (simDefaultPa.length) {
      // Check if SIM has valid EID and IMEI
      if (
        simDefaultPa.some(
          (x) =>
            x.value?.simProductInfo?.eid?.length !== 32 ||
            x.value?.simProductInfo?.imei?.length !== 15,
        )
      ) {
        logging.debug(
          "failed to add to cart because SIM EID or IMEI is not valid",
        );

        return false;
      }
    }

    const roomCount = bookingAttributes.find(
      (x) => x.productAttribute.name === "ROOM",
    )?.value?.quantity;
    if (roomCount) {
      const minAdult = ProdAttrUtils.findMinAdult(bookingAttributes);
      if (minAdult) {
        const adultCount = bookingAttributes.find(
          (x) =>
            x.productAttribute.name === "ADULT" ||
            x.productAttribute.name === "CHILD",
        )?.value?.quantity;
        if (adultCount && adultCount < minAdult) {
          logging.debug(
            `failed to add to cart because adult count ${adultCount} is less than min adult ${minAdult}`,
          );
          return false;
        }
      }
    }
  }

  // const dropOffLocation = bookingAttributes?.find(
  //   (x) => x.productAttribute.name === "DROP_OFF_LOCATION",
  // );
  // if (dropOffLocation && !dropOffLocation?.value?.text) {
  //   logging.debug(
  //     "failed to add to cart because drop off location is not selected",
  //   );
  //   return false;
  // }

  // Check if musical3rdParty is selected
  const musical3rdParty = bookingAttributes?.find(
    (x) => x.productAttribute.name === "MUSICAL_3RDPARTY",
  );
  // If musical3rdParty is selected, check if value is not empty and has not empty extProductBookingValues
  if (
    musical3rdParty &&
    (!musical3rdParty.value?.extProductBookingValues ||
      !musical3rdParty.value?.extProductBookingValues.length)
  ) {
    logging.debug(
      "failed to add to cart because musical 3rd party is not selected",
    );
    return false;
  }
  logging.debug("able to add to cart");
  return true;
};
